
import { ContentProps } from '@helper/util/landing/types'

import Container from '@/landing/component/container'
import Heading from '@/landing/component/heading'

import Contact from '@/landing/template/contact/ButtonGroup'

type Props = {
    contents: ContentProps;
}

const Landing = ({ contents }:Props) => {
  const { contactLabel, contactCaption } = contents
  return (
        <Container>
            <Heading caption={contactCaption} label={contactLabel} />
            <Contact contents={contents} />
        </Container>
  )
}

export default Landing
